import { _ChatApi } from "api/chat/chat";
import { useState } from "react";
import { useQuery } from "react-query";

export const useChat = () => {
  const [query, setQuery] = useState("");
  const { data, isLoading, refetch } = useQuery(
    ["chat", query],
    () => _ChatApi.index({ query }).then((res) => res),
    {
      keepPreviousData: true,
    }
  );
  return {
    data,
    isLoading,
    setQuery,
    refetch,
  };
};
